module.exports = __webpack_public_path__ + "static/media/up_blk.d4967bfc.svg";